/**
 * Service: paymentSettings (legacy AngularJS shell - Angular 18 service registered via downgradeInjectable)
 */
angular.module('acme.common.service.paymentSettings', []);
